import React from 'react';
import ReactDOM from 'react-dom';
import { translate } from 'react-i18next';

import ScheduleCounterTab from 'components/ScheduleCounterTab.js';
import Popover from 'components/popover/Popover.js';
import NotificationActions from "../actions/NotificationActions";

class ScheduleNotificationCounter extends ScheduleCounterTab {
  constructor(props) {
    super(props);

    this.state.maxNotificationsLoaded = false;
    this.state.totalNotificationsCount = 0;
    this.state.isOnline = Utils.isOnline();

    this._onCloseMyPopover = this._onCloseMyPopover.bind(this);
    this._onHandleClosePopover = this._onHandleClosePopover.bind(this);
    this.refreshLocalNotifications = this.refreshLocalNotifications.bind(this);
    this._onOnline = this._onOnline.bind(this);
    this._onOffline = this._onOffline.bind(this);
  }

  _onOnline() {
    this.setState({ isOnline: true });
    this.loadNotifications();
  }

  _onOffline() {
    this.setState({ isOnline: false });
  }

  componentDidMount() {
    OfflineStore.on('app:online', this._onOnline);
    OfflineStore.on('app:offline', this._onOffline);

    if (Utils.isOnline()) this.loadNotifications();

    NotificationsStore.on('notifications:load:success', this.refreshLocalNotifications, this);

    NotificationsStore.on('notifications:load:error', this.dataErrorHandler, this);

    document.addEventListener('popover:closed', this._onHandleClosePopover, this);
  }

  componentWillUnmount() {
    OfflineStore.off('app:online', this._onOnline);
    OfflineStore.off('app:offline', this._onOffline);
    NotificationsStore.off(null, null, this);
    NotificationsStore.off('notifications:load:error', this.dataErrorHandler, this);
    document.removeEventListener('popover:closed', this._onHandleClosePopover, this);
  }

  loadNotifications(startDate, endDate) {
    if (Utils.isNotDefined(startDate)) {
      const twoWeeksAgo = moment(Date.now()).subtract(2, 'weeks');
      startDate = twoWeeksAgo.format()
    }
    if (Utils.isNotDefined(endDate)) {
      endDate = moment(Date.now()).format();
    }

    NotificationActions.getNotifications(startDate, endDate);
  }

  loadMoreNotifications(e) {
    this.setState({maxNotificationsLoaded: true});
    const ninetyDaysAgo = moment(Date.now()).subtract(90, 'days').format();
    const today = moment(Date.now()).format();
    this.loadNotifications(ninetyDaysAgo, today);
  }

  _onHandleClosePopover(e) {
    if (ReactDOM.findDOMNode(this).contains(e.popOver)) {
      this._onCloseMyPopover();
    }
  }

  _onCloseMyPopover() {
    if (this.state.popOverActive) {
      this.setState({
        popOverActive: false,
        popTarget: null,
      });
    }
  }

  refreshLocalNotifications() {
    const notificationData = NotificationsStore.getAllNotifications();
    const totalNotificationsCount = notificationData.length;
    const unreadNotificationsCount = notificationData.filter((notification) => ! notification.is_read).length;
    this.setState({
      notificationData: notificationData,
      unreadNotificationsCount: unreadNotificationsCount,
      totalNotificationsCount: totalNotificationsCount
    });
  }

  markAllAsRead() {
    NotificationActions.markAllAsRead();
    NotificationsStore.updateAllLocalNotificationsAsRead();
    this.refreshLocalNotifications();
  }

  markAsRead(notificationId) {
    NotificationActions.markAsRead(notificationId);
    NotificationsStore.updateLocalNotificationAsRead(notificationId);
    this.refreshLocalNotifications();
  }

  renderNotificationContent(notification) {
    let itemContent;
    if (notification.is_read) {
      itemContent = <div className="notification-container">
                      <span className="notification-text read-notification">{notification.message}</span>
                      <div className="notification-details">
                        <small className="notification-date">{this.dateFormat(notification.date)}</small>
                        <small className="notification-from">{notification.from_name}</small>
                      </div>
                    </div>
    } else {
      itemContent = <div className="notification-container">
                      <span className="notification-dot">&nbsp;</span>
                      <span className="notification-text unread-notification">{notification.message}</span>
                      <div className="notification-details">
                        <small className="notification-date">{this.dateFormat(notification.date)}</small>
                        <small className="notification-from">{notification.from_name}</small>
                      </div>
                    </div>
    }
    return itemContent;
  }

  dateFormat(date) {
    const now = moment();
    const sendTime = moment(date);
    const duration = moment.duration(now.diff(sendTime));

    if (parseInt(duration.asHours()) >= 24) {
      return sendTime.format('MMMM D, YYYY');
    }

    return sendTime.fromNow();
  }

  renderNotificationsList() {
    return (
      this.state.notificationData.map((notification) => {
        return <li key={notification.notification_id} onClick={(e) => this.markAsRead(notification.notification_id, e)}>
          {this.renderNotificationContent(notification)}
        </li>;
      })
    )
  }

  render() {
    const countBackgroundClass = `legend-item-count ${this.props.colorProperty}`;
    const allNotificationsRead = this.state.unreadNotificationsCount === 0;

    return (
      <div onClick={e => this._onToggleMyPopover(e)}>
        <div className="legend-item" onMouseOver={this.handleRollOver}>
          <span className="legend-item-label">{this.props.notificationLabel}</span>
          <span className={countBackgroundClass}>{this.state.isOnline ? this.state.unreadNotificationsCount : ''}</span>
        </div>

        <Popover
          className="notification-popover"
          onHide={this._onCloseMyPopover.bind(this)}
          active={this.state.popOverActive}
          popTarget={this.state.popTarget}
          position="top"
        >
          {!this.state.isOnline ? (
            <div id="notifications-list-container">
              <ul className="notificationsList">
                <li><span>{this.props.t('ScheduleNotificationCounter.unavailable_offline')}</span></li>
              </ul>
            </div>
          ) : (
            <div>
              <ul id="notification-popover-header">
                <li style={{marginLeft: 0}}>
                  <h3>{this.props.t('ScheduleNotificationCounter.notifications')}</h3>
                </li>
                <li>
                  <button
                    id='mark-all-as-read'
                    className={allNotificationsRead ? 'inactive' : 'active'}
                    disabled={allNotificationsRead}
                    onClick={this.markAllAsRead.bind(this)}
                  >
                    {this.props.t('ScheduleNotificationCounter.mark_all_as_read')}
                  </button>
                </li>
              </ul>

              {this.state.totalNotificationsCount > 0 &&
                <div id="notifications-list-container">
                  <ul className="notificationsList">
                    {this.renderNotificationsList()}
                  </ul>

                  {!this.state.maxNotificationsLoaded &&
                    <div className='load-more-container'>
                      <button onClick={this.loadMoreNotifications.bind(this)} className="active">
                        {this.props.t('ScheduleNotificationCounter.load_more')}
                      </button>
                    </div>
                  }
                </div>
              }
              {this.state.totalNotificationsCount === 0 &&
                <div id="notifications-list-container">
                  <ul className="notificationsList">
                    <li><span>{this.props.t('ScheduleNotificationCounter.no_notifications')}</span></li>
                  </ul>
                </div>
              }
            </div>
          )}
        </Popover>
      </div>
    );
  }
}

export default translate()(ScheduleNotificationCounter);
